import withSharedStyles from "../theme/Shared.style";

// Product grid cells: ~168px+ columns, 20px gutters × 32px rows
// (2 per row on phones, 4 under 1100, 4–6 on desktop, 7–8 on wide screens).
const withCustomStyles = withSharedStyles(theme => ({
  tileItem: {
    padding: "0 10px 32px",
    [theme.media.phone]: {
      padding: "0 6px 24px"
    },
    // MUI Grid stops at lg={2} (6 per row); wide screens get 7, then 8.
    // !important beats the Grid's own lg flex-basis/max-width rules.
    [theme.media.wide]: {
      flexBasis: `${100 / 7}% !important`,
      maxWidth: `${100 / 7}% !important`
    },
    [theme.media.xwide]: {
      flexBasis: "12.5% !important",
      maxWidth: "12.5% !important"
    }
  }
}));

export default withCustomStyles;
